import React from 'react'
import styled, { css } from 'styled-components'
import { ReactComponent as CheckIcon } from '../../assets/icons/green-check.svg'
import { ReactComponent as WarningIcon } from '../../assets/icons/warning-icon.svg'
import { ReactComponent as DangerIcon } from '../../assets/icons/danger-icon.svg'
import { ReactComponent as InfoIcon } from '../../assets/icons/info-icon.svg'
import { ReactComponent as CloseIcon } from '../../assets/icons/x-icon.svg'
import { ReactComponent as Percentage } from '../../assets/icons/badge-percentage.svg'
import { ReactComponent as LockIcon } from '../../assets/icons/lock-alt.svg'

const alertStyles = {
  info: css`
    background-color: #D2E1F4;
  `,
  success: css`
    background-color: #DAF2D4;
  `,
  warning: css`
    background-color: #FAECCA;
  `,
  danger: css`
    background-color: #FCE2E7;
  `,
  campaign: css`
    background-color: #DAF2D4;
  `,
  lock: css`
    background-color: #D2E1F4;
  `
}

export const AlertContainer = styled.div`
  align-items: ${({ type }) => (type === 'campaign' ? 'start' : 'center')};
  padding: 16px;
  display: flex;
  border-radius: 12px;
  gap: 16px;
  width: 100%;
  ${({ type }) => (
    alertStyles[type]
  )}
`

const Icon = styled.i`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
`
const Message = styled.span`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 145%;
  color: #555;
  flex: 1;

  strong {
    font-family: 'Open Sans';
    font-weight: 600;
  }
`
const CloseButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  border: none;
  width: 24px;
  height: 24px;
  padding: 0;
  svg path {
    fill: #555;
  }
  &:focus {
    outline: none;
  }
`

const icons = {
  info: <InfoIcon />,
  success: <CheckIcon />,
  warning: <WarningIcon />,
  danger: <DangerIcon />,
  campaign: <Percentage />,
  lock: <LockIcon />
}

const Alert = ({ type = 'info', show, onClose, children, customIcon }) => {
  return (
    <>
      {show && (
        <AlertContainer type={type}>
          <Icon>
            {customIcon || icons[type]}
          </Icon>
          <Message>{children}</Message>
          {onClose &&
            <CloseButton onClick={() => onClose()}>
              <CloseIcon />
            </CloseButton>}
        </AlertContainer>
      )}
    </>
  )
}

export default Alert
